// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TDeleteConversationsRequestPayload,
  TDeleteConversationsResponsePayload,
  TGetConversationMessagesRequestPayload,
  TGetConversationMessagesResponsePayload,
  TGetConversationWithMessagesRequestPayload,
  TGetConversationWithMessagesResponsePayload,
  TGetMessageRequestPayload,
  TGetMessageResponsePayload,
  TGetProjectMessagesRequestPayload,
  TGetProjectMessagesResponsePayload,
  TGetUserConversationsRequestPayload,
  TGetUserConversationsResponsePayload,
  TSendProjectMessageFeedbackRequestPayload,
  TSendProjectMessageFeedbackResponsePayload,
} from './conversations.types.ts';

export const createConversationsApi = (transport: TApiTransport) => ({
  /** Deletes the user's conversations */
  deleteConversations: (
    payload: TDeleteConversationsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteConversationsRequestPayload,
      TDeleteConversationsResponsePayload
    >('/delete_conversations', payload, options),

  /** Lists a conversation's messages */
  getConversationMessages: (
    payload: TGetConversationMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetConversationMessagesRequestPayload,
      TGetConversationMessagesResponsePayload
    >('/get_conversation_messages', payload, options),

  /** Returns a conversation with its messages */
  getConversationWithMessages: (
    payload: TGetConversationWithMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetConversationWithMessagesRequestPayload,
      TGetConversationWithMessagesResponsePayload
    >('/get_conversation_with_messages', payload, options),

  /** Returns a message */
  getMessage: (
    payload: TGetMessageRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetMessageRequestPayload, TGetMessageResponsePayload>(
      '/get_message',
      payload,
      options,
    ),

  /** Lists the project's messages */
  getProjectMessages: (
    payload: TGetProjectMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectMessagesRequestPayload,
      TGetProjectMessagesResponsePayload
    >('/get_project_messages', payload, options),

  /** Lists the user's conversations */
  getUserConversations: (
    payload: TGetUserConversationsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetUserConversationsRequestPayload,
      TGetUserConversationsResponsePayload
    >('/get_user_conversations', payload, options),

  /** Records feedback on a message */
  sendProjectMessageFeedback: (
    payload: TSendProjectMessageFeedbackRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSendProjectMessageFeedbackRequestPayload,
      TSendProjectMessageFeedbackResponsePayload
    >('/send_project_message_feedback', payload, options),
});
